import DocViewer from './src/main';

/* istanbul ignore next */
DocViewer.install = function(Vue) {
  Vue.component(DocViewer.name, DocViewer);
};

export default DocViewer;
